const breakPointPC = 1279;
const breakPointSP = 767;
let resizeFlag     = false;
let headerFlag = false;
let windowWidth    = window.innerWidth;
let windowHeight   = window.innerHeight;
let windowWidthJ   = $(window).width();


// ------------------------------------------------------------------------
// pageTop
// ----- BOTH
// ------------------------------------------------------------------------
const headerHamburger = () => {
  $('.st-Header_Inner_Hamburger').click(function () {
    $(this).parents('header').toggleClass('active');
  });
  $(".anchor a").on("click", function(){
    $(this).parents('header').toggleClass('active');
  });
};


// ------------------------------------------------------------------------
// bnrSlide
// ----- BOTH
// ------------------------------------------------------------------------
const approachSlide = () => {

var approachSwiper;
  approachSwiper = new Swiper('.swiper-container', {
    watchOverflow: true,
    // width: 500,
    slidesPerView: 1,
    // loopedSlides: 2,
    // spaceBetween: 40,
    loop: true,
    grabCursor: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false // ユーザーのスワイプ操作を検出したら自動再生を中止するか
    },
    speed: 1000,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      hideOnClick: true,
    },
    breakpoints: {
      767: {
        // loop: !hasOneSlide,
        slidesPerView: 1
      }
    },
  });
  // document.querySelector('.slide1').addEventListener('click', function (e) {
  //   approachSwiper.slideTo(0, 0);
  //   element.classList.toggle('active');
  // });
  // document.querySelector('.slide2').addEventListener('click', function (e) {
  //   approachSwiper.slideTo(1, 0);
  // });
  // document.querySelector('.slide3').addEventListener('click', function (e) {
  //   approachSwiper.slideTo(2, 0);
  // });
};

// ------------------------------------------------------------------------
// pageTop
// ----- BOTH
// ------------------------------------------------------------------------
// const pageTop = () => {
//
//
//   $(window).on("scroll", function(){
//     var scrollPosition = $(window).scrollTop();
//     // if(windowW >= 768){
//       if(scrollPosition >= 50){
//         $(".sw-Top").removeClass('is-Hidden');
//       } else {
//         $(".sw-Top").addClass('is-Hidden');
//       }
//     // }
//   });
//
//   $(".sw-Top").on("click", function(){
//     var linkSpeed    = 600;
//     $("html, body").animate({scrollTop: 0}, linkSpeed, "easeOutQuint");
//     return false;
//   });
// };



// ------------------------------------------------------------------------
// visibleButton
// ----- BOTH
// ------------------------------------------------------------------------
// const visibleButton = () => {
//   let targetButton = document.querySelector('.sw-Top');
//   let targetHeight = 100;
//   window.addEventListener('scroll', () => {
//     let scrollHeight = window.pageYOffset;
//     if (scrollHeight > targetHeight) {
//       targetButton.classList.remove('is-Hidden');
//     } else {
//       targetButton.classList.add('is-Hidden');
//     }
//   });
// }



// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^=#]").on("click", function(){
    var linkSpeed    = 800;
    var linkSpeed2    = 5000;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 1;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition + linkAdjust}, linkSpeed, "swing");
    return false;
    // var scrollPosition = $(window).scrollTop();
    // if(scrollPosition >= 50){
    //   $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    //   return false;
    // } else {
    //   $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed2, "swing");
    //   return false;
    // }
  });
};




// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const scrollMagic = () => {
  $(function(){
      var controller = new ScrollMagic();
      var scene = new ScrollScene({
        triggerElement: "#main",
        duration: windowHeight*1 ,
        triggerHook : "onLeave"})
              .setPin("#main")
              .addTo(controller);
      // var scene2 = new ScrollScene({triggerElement: ".st-Header", duration: windowHeight*1.1 , triggerHook : "onLeave"})
      //         .setPin(".st-Header")
      //         .addTo(controller);
      $(window).on("scroll", function(){
        var scrollPosition = $(window).scrollTop();
        // if(windowW >= 768){
          if(scrollPosition >= 50){
            $(".front").addClass('is-Hidden');
            $(".behind").removeClass('is-Hidden');
          } else {
            $(".front").removeClass('is-Hidden');
            $(".behind").addClass('is-Hidden');
          }
        // }
      });
  });
};



// ------------------------------------------------------------------------
// fadeImage
// ----- BOTH
// ------------------------------------------------------------------------
const fadeImage = () => {
  $(".fadepc img:not(:first-child)").hide();
  $(".fadesp img:not(:first-child)").hide();
  if(windowWidthJ > breakPointSP){
    setInterval(function() {
      $(".fadepc img:first-child").fadeOut("slow").next("img").fadeIn("slow").end().appendTo(".fadepc");
    },4000);
  }else{
    setInterval(function() {
      $(".fadesp img:first-child").fadeOut("slow").next("img").fadeIn("slow").end().appendTo(".fadesp");
    },4000);
  }

};




// ------------------------------------------------------------------------
// menuCurrent
// ----- BOTH
// ------------------------------------------------------------------------
const menuCurrent = () => {
  $(function(){
		$(window).on('scroll' , function(){
			$('.st-Header_Inner_GlobalMenu .anchor a').each(function() {
				//変数の作成
				var $window = $(window);
        // var $thisTop = $('.st-Header_Inner_GlobalMenu .anchor');
				var $this = $(this);

				var linkTo =  $this.attr('href'); //href=""取得
				var $target = $(linkTo);

				var topLimit= $target.offset().top;
				var bottomLimit = $target.offset().top + $target.outerHeight();

				if(topLimit <= $window.scrollTop() && $window.scrollTop() < bottomLimit){
					$this.parent().addClass('current');
				}else{
					$this.parent().removeClass('current');
				}
			});
		});
	});
};




export {
  headerHamburger,
  scrollMagic,
  anchorLink,
  fadeImage,
  menuCurrent,
  approachSlide,
  // activeSubmit,
  // formCheckSend,
  // formCheckSendEn,
  // animateFade,
  // distribution404,
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js